// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Sign in / create an account. In the app it floats over the conversation
 * (.auth-overlay, AppShell.css), which stays behind the scrim; in the portal
 * it is the front door. The one raised surface, a control edge, line buttons.
 */

.auth-container {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  width: 100%;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  padding: 28px 24px 22px;
  background: var(--brand-surface);
  color: var(--brand-fg);
  border: 1px solid var(--brand-line-control);
  border-radius: var(--radius-lg);
  animation: aprSheetIn var(--dur-base) var(--ease-out);
}

.auth-header {
  margin-bottom: 20px;
}

.auth-title {
  display: flex;
  margin: 0;
  color: var(--brand-fg);
  line-height: 1;
}

.auth-title .apr-lockup {
  display: block;
  height: 24px;
  width: auto;
}

.auth-subtitle {
  margin: 10px 0 0;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--brand-muted);
}

/* Sign in / Create account: a segmented choice; selected is a 2 px white
   edge and a check, never a fill. */
.auth-mode-toggle {
  display: flex;
  margin-bottom: 20px;
}

.auth-mode-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 48px;
  padding: 0 12px;
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-muted);
  font-size: 0.9375rem;
  font-weight: 600;
}

.auth-mode-btn:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }
.auth-mode-btn:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }
.auth-mode-btn:hover { color: var(--brand-fg); }

.auth-mode-btn.active {
  position: relative;
  z-index: 1;
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
  color: var(--brand-fg);
}

.form-title {
  margin: 0 0 8px;
  font-family: var(--font-sans);
  font-size: 1.25rem;
  line-height: 1.3;
  font-weight: 600;
  color: var(--brand-fg);
}

.auth-benefits {
  margin: 0 0 18px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.form-group {
  margin-bottom: 14px;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--brand-muted);
}

.auth-card .auth-form .input {
  width: 100%;
}

.auth-submit {
  margin-top: 6px;
  min-height: 52px;
}

.auth-submit:disabled {
  cursor: wait;
}

.btn-link {
  min-height: 44px;
  padding: 0 4px;
  font-size: 0.9375rem;
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.btn-link:hover {
  text-decoration-thickness: 2px;
}

.auth-links {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
}

.error-message {
  margin-bottom: 14px;
}

.success-message {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.success-message .apr-icon {
  margin-top: 2px;
  color: var(--brand-fg);
}

.success-message p {
  margin: 0 0 4px;
}

.reset-info,
.auth-consent,
.guest-hint,
.auth-info {
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.reset-info,
.auth-consent {
  margin: 0 0 12px;
}

.auth-guest {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--brand-line);
  text-align: center;
}

.auth-guest .guest-continue {
  font-weight: 600;
}

.auth-guest .guest-hint {
  margin: 4px 0 0;
}

.auth-footer {
  margin-top: 18px;
  text-align: center;
}

.footer-text,
.auth-footer .footer-text {
  margin: 6px 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-subtle);
}

.auth-policy-links a {
  color: var(--brand-muted);
}

.auth-card .loading-text {
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
}

@media (max-width: 600px) {
  .auth-card {
    padding: 24px 20px 20px;
  }
}

@media (max-width: 420px) {
  .auth-mode-btn {
    padding: 0 8px;
    font-size: 0.875rem;
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthForm.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,2CAA2C;EAC3C,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;oCACoC;AACpC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,6BAA6B,oDAAoD,EAAE;AACnF,4BAA4B,oDAAoD,EAAE,iBAAiB,EAAE;AACrG,uBAAuB,sBAAsB,EAAE;;AAE/C;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * Sign in / create an account. In the app it floats over the conversation\n * (.auth-overlay, AppShell.css), which stays behind the scrim; in the portal\n * it is the front door. The one raised surface, a control edge, line buttons.\n */\n\n.auth-container {\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 0;\n  width: 100%;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 440px;\n  padding: 28px 24px 22px;\n  background: var(--brand-surface);\n  color: var(--brand-fg);\n  border: 1px solid var(--brand-line-control);\n  border-radius: var(--radius-lg);\n  animation: aprSheetIn var(--dur-base) var(--ease-out);\n}\n\n.auth-header {\n  margin-bottom: 20px;\n}\n\n.auth-title {\n  display: flex;\n  margin: 0;\n  color: var(--brand-fg);\n  line-height: 1;\n}\n\n.auth-title .apr-lockup {\n  display: block;\n  height: 24px;\n  width: auto;\n}\n\n.auth-subtitle {\n  margin: 10px 0 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n/* Sign in / Create account: a segmented choice; selected is a 2 px white\n   edge and a check, never a fill. */\n.auth-mode-toggle {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.auth-mode-btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 48px;\n  padding: 0 12px;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-muted);\n  font-size: 0.9375rem;\n  font-weight: 600;\n}\n\n.auth-mode-btn:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }\n.auth-mode-btn:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }\n.auth-mode-btn:hover { color: var(--brand-fg); }\n\n.auth-mode-btn.active {\n  position: relative;\n  z-index: 1;\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n  color: var(--brand-fg);\n}\n\n.form-title {\n  margin: 0 0 8px;\n  font-family: var(--font-sans);\n  font-size: 1.25rem;\n  line-height: 1.3;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.auth-benefits {\n  margin: 0 0 18px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.form-group {\n  margin-bottom: 14px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.auth-card .auth-form .input {\n  width: 100%;\n}\n\n.auth-submit {\n  margin-top: 6px;\n  min-height: 52px;\n}\n\n.auth-submit:disabled {\n  cursor: wait;\n}\n\n.btn-link {\n  min-height: 44px;\n  padding: 0 4px;\n  font-size: 0.9375rem;\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.btn-link:hover {\n  text-decoration-thickness: 2px;\n}\n\n.auth-links {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.error-message {\n  margin-bottom: 14px;\n}\n\n.success-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 14px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.success-message .apr-icon {\n  margin-top: 2px;\n  color: var(--brand-fg);\n}\n\n.success-message p {\n  margin: 0 0 4px;\n}\n\n.reset-info,\n.auth-consent,\n.guest-hint,\n.auth-info {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.reset-info,\n.auth-consent {\n  margin: 0 0 12px;\n}\n\n.auth-guest {\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--brand-line);\n  text-align: center;\n}\n\n.auth-guest .guest-continue {\n  font-weight: 600;\n}\n\n.auth-guest .guest-hint {\n  margin: 4px 0 0;\n}\n\n.auth-footer {\n  margin-top: 18px;\n  text-align: center;\n}\n\n.footer-text,\n.auth-footer .footer-text {\n  margin: 6px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-subtle);\n}\n\n.auth-policy-links a {\n  color: var(--brand-muted);\n}\n\n.auth-card .loading-text {\n  color: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n@media (max-width: 600px) {\n  .auth-card {\n    padding: 24px 20px 20px;\n  }\n}\n\n@media (max-width: 420px) {\n  .auth-mode-btn {\n    padding: 0 8px;\n    font-size: 0.875rem;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
